import React, { useState } from 'react';
import { useProspectAuth } from './ProspectAuthContext';
import logoImg from '../assets/images/logo/logo-topo360.png';

const Logins = () => {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login }               = useProspectAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const payload = await login(email, password);
      window.location.replace(payload.role === 'admin' ? '/admin/dashboard' : '/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'E-mail ou senha inválidos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-page'>
      <div className='login-left-panel' />
      <div className='login-right-panel'>
        <div className='login-form-box'>
          <div className='text-center mb-4'>
            <img src={logoImg} alt='Topo 360' style={{ height: 72 }} />
          </div>

          <h4 className='login-title'>Faça o seu login</h4>
          <p className='login-subtitle'>Entre com suas credenciais para acessar o sistema</p>

          {error && (
            <div className='login-error'>{error}</div>
          )}

          <form onSubmit={handleSubmit} autoComplete='off'>
            <div className='login-field'>
              <label className='login-label'>
                email <span className='required-dot'>*</span>
              </label>
              <input
                type='email'
                className='login-input'
                placeholder='meu@email.com'
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete='off'
                required
              />
            </div>

            <div className='login-field'>
              <div className='login-label-row'>
                <label className='login-label'>
                  senha <span className='required-dot'>*</span>
                </label>
                <a href='/forgot-password' className='login-forgot'>esqueci minha senha</a>
              </div>
              <div className='login-input-wrap'>
                <input
                  type={showPass ? 'text' : 'password'}
                  className='login-input'
                  placeholder='••••••••'
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete='new-password'
                  required
                />
                <button
                  type='button'
                  className='login-eye-btn'
                  onClick={() => setShowPass(!showPass)}
                  tabIndex={-1}
                >
                  {showPass ? (
                    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9-4-9-7s4-7 9-7a9.97 9.97 0 015.338 1.538M15 12a3 3 0 11-6 0 3 3 0 016 0z' />
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 3l18 18' />
                    </svg>
                  ) : (
                    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 12a3 3 0 11-6 0 3 3 0 016 0z' />
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z' />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button type='submit' className='login-btn' disabled={loading}>
              {loading ? (
                <span className='login-spinner' />
              ) : (
                <>
                  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none' viewBox='0 0 24 24' stroke='currentColor' style={{ marginRight: 8 }}>
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1' />
                  </svg>
                  Entrar
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Logins;
